import React from 'react';
import Layout from '../components/Layout';
import Landing from '../sections/Landing';

const IndexPage = () => (
  <Layout>
    <Landing />
  </Layout>
);

export default IndexPage;
